module.exports = __webpack_public_path__ + "static/media/phd_synopsis_template.3a7bccd4.zip";